import { DashboardV2Filters } from '../types'

const KEPT_ON_RESET = 'details'

const countActiveFilters = (filters: DashboardV2Filters): number =>
  Object.entries(filters ?? {}).reduce<number>((count, [key, value]) => {
    if (key === KEPT_ON_RESET) return count
    if (Array.isArray(value)) return count + value.length
    return value ? count + 1 : count
  }, 0)

export default countActiveFilters
